'use strict';

/* globals define, ajaxify, $, config, socket, app, RELATIVE_PATH */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/groups/invitations', [
	'autocomplete',
	'components',
	'translator',
	'bootbox'
], function (autocomplete, components, translator, bootbox) {
	var Invitations = {};

	Invitations.init = function () {
		handleMemberInvitations();
		handleActions();
	};

	function handleMemberInvitations() {
		$('[component="groups/members/bulk-invite-button"]').on('click', function () {
			var invitations = $('[component="groups/members/bulk-invite"]').val().split(',');

			invitations = invitations.filter(function (invitation) {
				return invitation.length;
			});

			socket.emit('plugins.invitation.issueMassInvite', {
				invitations,
				groupName: ajaxify.data.group.name,
			}, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				ajaxify.refresh();
			});

			return false;
		});
	}

	function handleActions() {
		components.get('groups/container').on('click', '[data-action]', function () {
			var btnEl = $(this);
			var userRow = btnEl.parents('[data-uid]');
			var ownerFlagEl = userRow.find('.member-name > i');
			var isOwner = !ownerFlagEl.hasClass('invisible');
			var uid = userRow.attr('data-uid');
			var action = btnEl.attr('data-action');

			switch (action) {
			case 'toggleOwnership':
				socket.emit('groups.' + (isOwner ? 'rescind' : 'grant'), {
					toUid: uid,
					groupName: ajaxify.data.group.name,
				}, function (err) {
					if (!err) {
						ownerFlagEl.toggleClass('invisible');
					} else {
						app.alertError(err.message);
					}
				});
				break;

			case 'kick':
				translator.translate('[[groups:details.kick_confirm]]', function (translated) {
					bootbox.confirm(translated, function (confirm) {
						if (!confirm) {
							return;
						}

						socket.emit('groups.kick', {
							uid: uid,
							groupName: ajaxify.data.group.name,
						}, function (err) {
							if (!err) {
								userRow.slideUp().remove();
							} else {
								app.alertError(err.message);
							}
						});
					});
				});
				break;
			case 'userUninvite':
				socket.emit('plugins.invitation.uninvite', {
					email: $(this).attr('data-email').replace(/[ \t]/g, ''),
					groupName: ajaxify.data.group.name
				}, function (error) {
					if (error !== null) {
						app.alertError(error);
					}

					ajaxify.refresh();
				});

				break;
			case 'userReinvite':
				socket.emit('plugins.invitation.reinvite', {
					email: $(this).attr('data-email').replace(/[ \t]/g, ''),
					groupName: ajaxify.data.group.name
				}, function (error) {
					if (error !== null) {
						app.alertError(error);
					}

					app.alertSuccess('[[invite:success-invited]]');
				});
				break;
			case 'join':	// intentional fall-throughs!
			case 'leave':
			case 'accept':
			case 'reject':
			case 'issueInvite':
			case 'rescindInvite':
			case 'acceptInvite':
			case 'rejectInvite':
			case 'acceptAll':
			case 'rejectAll':
				socket.emit('groups.' + action, {
					toUid: uid,
					groupName: ajaxify.data.group.name,
				}, function (err) {
					if (!err) {
						ajaxify.refresh();
					} else {
						app.alertError(err.message);
					}
				});
				break;
			}
		});
	}

	return Invitations;
});
